import { useState } from 'react';
import StatusBar from 'common/components/StatusBar';
import OfflineModeInfoModal from 'common/components/OfflineModeInfoModal';
import { ReactComponent as InfoIcon } from 'common/images/info-tooltip.svg';
import { mobxInjectSelect } from 'common/utils';
import BEM from 'common/bem';

const classes = BEM.with('LocalServerStatusBar');

const cloudUrl = process.env.CLOUD_URL;

export const OFFLINE_MODE_BANNER_TEXT = 'Offline mode – Limited functionality';
export const OFFLINE_MODE_BANNER_INFO_LABEL = 'More information about offline mode';

type MobxProps = {
  networkStatus: string;
  isLocalServer: boolean;
};

function LocalServerStatusBar({ networkStatus, isLocalServer }: MobxProps) {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  if (!isLocalServer) return null;

  const canReturnToCloud = networkStatus === 'ONLINE' && !!cloudUrl;

  const handleReturnToCloud = () => {
    if (cloudUrl) {
      window.location.href = cloudUrl;
    }
  };

  return (
    <StatusBar variant={canReturnToCloud ? 'success' : 'error'} className={classes()}>
      <span className={classes('message')}>{OFFLINE_MODE_BANNER_TEXT}</span>
      <button
        type="button"
        className={classes('info-button')}
        aria-label={OFFLINE_MODE_BANNER_INFO_LABEL}
        data-test-id={'offline mode banner info'}
        onClick={() => setIsInfoModalOpen(true)}
      >
        <InfoIcon className={classes('info-icon')} aria-hidden="true" />
      </button>
      {canReturnToCloud && (
        <button type="button" className={classes('button')} onClick={handleReturnToCloud}>
          Return to Cloud
        </button>
      )}
      <OfflineModeInfoModal isOpen={isInfoModalOpen} onClose={() => setIsInfoModalOpen(false)} />
    </StatusBar>
  );
}

export default mobxInjectSelect<Record<string, never>, MobxProps>({
  networkStatusStore: ['networkStatus'],
  messengerStore: ['isLocalServer'],
})(LocalServerStatusBar);
